<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import tableheader from "../tableheader/index";
import addedit from "./addedit";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Bitiş Tarihi Yaklaşanlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader, 
    Layout,
    PageHeader, treeselect,addedit,tableheader
  },
  data() {
    return {
      title: "Bitiş Tarihi Yaklaşanlar",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Bitiş Tarihi Yaklaşanlar",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      Filter: {
        OrderBy: "Asc=Tahminibitis",
        Atananbirimid: null, 
        Oncelikid: null,
        Atananpersonelid: null,
        Tahminibitisbas: null,
        Tahminibitisbit: null
      },
      FilterText: ""
    };
  },

  methods: {
    Get() {
   
      this.FilterText = "&Desc=Tahminibitis&Bitistarihsorgulama=true&" + this.Filter.OrderBy

      if (this.Filter.Atananbirimid != null && this.Filter.Atananbirimid != "") {
        this.FilterText += "&Atananbirimid=" + this.Filter.Atananbirimid
      }
  
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        this.FilterText += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Atananpersonelid != null && this.Filter.Atananpersonelid != "") {
        this.FilterText += "&Atananpersonelid=" + this.Filter.Atananpersonelid
      }
      if (this.Filter.Tahminibitisbas != null && this.Filter.Tahminibitisbas != "") {
        this.FilterText += "&Tahminibitisbas=" + this.Filter.Tahminibitisbas
      }
      if (this.Filter.Tahminibitisbit != null && this.Filter.Tahminibitisbit != "") {
        this.FilterText += "&Tahminibitisbit=" + this.Filter.Tahminibitisbit
      }
 
      this.ActionsFilterGet({
        Service: "tlptalep",
        Page: this.Page,
        Filter: this.FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    goToDetailPage(Id) { 
        const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
        window.open(routeData.href, '_blank'); 
    },
    getRowClass(tahminibitis) {
      if (!tahminibitis) return '';

      const today = new Date();
      const dateToCheck = new Date(tahminibitis);
      const diffInDays = (dateToCheck - today) / (1000 * 60 * 60 * 24);

      if (diffInDays < 0) {
        return 'table-danger';  
      } else if (diffInDays <= 7) {
        return 'table-warning'; 
      } else if (diffInDays <= 30) {
        return 'table-info';  
      } else {
        return '';  
      }
    },

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"> 
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3"  >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle"
                          :key="Filter.Atananbirimid">
                          <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananbirimid" />
                          <treeselect-value :value="Filter.Atananbirimid" />
                        </b-form-group>
 
                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text"
                          :label="FormDataType.Atananpersonelid.FieldTitle" :key="Filter.Atananpersonelid">
                          <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananpersonelid" />
                          <treeselect-value :value="Filter.Atananpersonelid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Tahmini Bitiş Tarihi Başlangıç">
                          <b-form-input v-model="Filter.Tahminibitisba" type="date"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Tahmini Bitiş Tarihi Bitiş">
                          <b-form-input v-model="Filter.Tahminibitisbit" type="date"></b-form-input>
                        </b-form-group>

                        <div class="col-lg-3 mt-4">
                          <button class="btn btn-success " data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
              <div class=" col-md-10 mb-3">
  <h5>Renk Anlamları</h5>
  <div class="d-flex flex-wrap gap-3 ">
    <span class="badge bg-danger p-3">Geçmiş Tarih (Kırmızı)</span>
    <span class="badge bg-warning text-dark p-3">7 Gün İçinde (Turuncu)</span>
    <span class="badge bg-info text-dark p-3">1 Ay İçinde (Açık mavi)</span>
    <span class="badge bg-light text-dark p-3">Daha Fazla Süre (Varsayılan)</span>
  </div>
</div>

<b-dropdown variant="success" class=" col-lg-1 btn  btn-rounded  mt-3 " style="height: 50px;">
                            <template v-slot:button-content>
                              <i class="mdi mdi-file-export-outline me-1"></i>Yazdır <i
                                class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepbitistarihiyaklasan', DowlandName: 'Bitiş Tarihi Yaklaşan Talepler', FileName: 'tlptalepbitistarihiyaklasan', FileFormat: 'xlsx', Filter: FilterText })">Excel</b-dropdown-item>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepbitistarihiyaklasan', DowlandName: 'Bitiş Tarihi Yaklaşan Talepler', FileName: 'tlptalepbitistarihiyaklasan', FileFormat: 'pdf', Filter: FilterText })">Pdf</b-dropdown-item>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepbitistarihiyaklasan', DowlandName: 'Bitiş Tarihi Yaklaşan Talepler', FileName: 'tlptalepbitistarihiyaklasan', FileFormat: 'docx', Filter: FilterText })">Word</b-dropdown-item>
                          </b-dropdown>
                     

<b-form-group  class="col-lg-1 text-end"
                              label="Kayıt Sayısı" 
                            >
                            <select
                                  v-model="Page.PageSize" 
                                  class="form-select" 
                                  @change="Get()"
                                >
                                  <option value="10"  >10</option>
                                  <option value="20"  >20</option>
                                  <option value="50"  >50</option>
                                  <option value="100"  >100</option>
                                  <option value="1000"  >1000</option> 
                                </select>
                            </b-form-group>
                          </div>
 
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <tableheader @OrderBy="Filter.OrderBy = $event , Get()" :Data=' [ 
                        { "Takipno": "Takip No" }, 
                        { "Baslik": "Başlık" }, 
                        { "Olusturan": "Talep Sahibi" }, 
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" }, 
                        { "Taleptip": "Talep Tipi" }, 
                        { "Atananbirim": "Atanan Birim" },  
                        { "Durum": "Durum" }, 
                        { "Oncelik": "Öncelik" },  
                        { "Atananpersonel": "Atanan Temsilci" }, 
                        { "Created": "Oluşturma Tarihi" },
                        { "Isgucu": "İş Gücü" },  
                        { "": "İşlem" },   
                      ]  ' /> 
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id" 
                    :class="getRowClass(Data.Tahminibitis)">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td>{{ Data.Olusturan }}</td> 
                      <td>{{ Data.Tahminibitis != null ? formatDateTable(Data.Tahminibitis) : '' }}</td>
                      <td>{{ Data.Taleptip }}</td>
                      <td>{{ Data.Atananbirim }}</td>
                      <td>{{ Data.Durum }}</td>
                      <td>{{ Data.Oncelik }}</td>
                      <td>{{ Data.Atananpersonel }}</td>
                      <td>{{ Data.Created != null ? formatDateTable(Data.Created) : '' }}</td>
                      <td>{{ Data.Isgucu }}</td>
                      <td>
                        <div class="
                            action-is
                            w-100 
                            d-flex
                            justify-content-center
                            align-items-center
                          ">
                          <b-button-group>
                            <b-button v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Id)"><i
                                class="far fa-eye"></i></b-button>
                            <b-button v-b-tooltip.hover title="Düzenle" variant="success" v-b-modal.tlptalep
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                            <b-button variant="danger" v-b-tooltip.hover title="Sil" v-if="0"
                              @click="Delete('tlptalep', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />   
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"    
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, Math.ceil(Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get"  />
    </Layout>
  </Loader>
</template>
